import {
  DevCycleUserIdentity,
  DevCycleUserIdentityStatus,
} from 'src/hooks/useIdentifyUser';

export const getLoadingDevCycleUserIdentity = (): DevCycleUserIdentity => ({
  status: DevCycleUserIdentityStatus.LOADING,
});

export const getAnonymousDevCycleUserIdentity = (): DevCycleUserIdentity => ({
  status: DevCycleUserIdentityStatus.ANONYMOUS,
});

export const getAuthenticatedDevCycleUserIdentity = (
  userId: string,
  corpId?: string
): DevCycleUserIdentity => ({
  status: DevCycleUserIdentityStatus.AUTHENTICATED,
  userId,
  corpId,
});

export const getNextDevCycleUserIdentity = (userData?: {
  userId?: string;
  corpId?: string;
}): DevCycleUserIdentity =>
  userData?.userId
    ? getAuthenticatedDevCycleUserIdentity(userData.userId, userData.corpId)
    : getAnonymousDevCycleUserIdentity();
